module.exports = __webpack_public_path__ + "img/shuxue.e4e31f9e.png";